// dependencies
import { Map } from "immutable";

export const getCompanyReducer = (state) => state.getIn(["company"], Map());
export const getCompanyUsersObject = (state) => state.getIn(["company", "companyUsers"], Map());
